import 'css-chunksrc/client/scenes/documentCreation/form/templates/preview/styles.scss';export default {
  "preview": "_preview_1uubj_1",
  "selected": "_selected_1uubj_12",
  "header": "_header_1uubj_16",
  "fileIcon": "_fileIcon_1uubj_22",
  "name": "_name_1uubj_27",
  "templateBox": "_templateBox_1uubj_33",
  "loader": "_loader_1uubj_41",
  "skeleton": "_skeleton_1uubj_49"
};